// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { HTMLAttributes } from "react";
import styled from "styled-components";

interface DotButtonProps extends HTMLAttributes<HTMLButtonElement> {
    selected: boolean;
    altColor?: boolean;
}

export const DotButton = styled.button<DotButtonProps>`
    width: ${pxToRem(10)};
    height: ${pxToRem(10)};
    background-color: ${props =>
        props.selected ? getColor("primary") : getColor(props.altColor ? "common.borderLight" : "common.disabled")};
    border-radius: 50%;
    cursor: pointer;
    border: none;
    padding: 0;
    margin: 0 0.5em;
`;
